import { __assign } from './external/tslib/tslib.es6.js';
import * as React from 'react';

var SvgStarOutline = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { clipPath: "url(#star-outline_svg__a)" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.522 8.585 12 1 8.478 8.585 0 9.512l6.3 5.615-1.716 8.159L12 19.17l7.416 4.115-1.716-8.159L24 9.512l-8.478-.927Zm3.79 2.426-5.129-.56L12 5.747 9.816 10.45l-5.128.561 3.808 3.394-1.054 5.007L12 16.884l4.558 2.528-1.054-5.007 3.808-3.394Z", fill: "currentColor" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "star-outline_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" }))))); };

export { SvgStarOutline as default };
